<template>
  <div>
    <a-form @submit="handleSubmit" :form="form" class="form">
      <a-card title="阿里云RDS配置" class="card" :bordered="true">
        <a-button
          slot="extra"
          size="small"
          :loading="isSubmit"
          v-if="isEdit"
          type="primary"
          @click="handleSubmit">
          提交
        </a-button>
        <a-button slot="extra" size="small" v-if="isEdit" @click="isEdit = false" style="margin-left:15px;">取消</a-button>
        <a-button slot="extra" size="small" v-if="!isEdit" @click="isEdit = true" type="primary">编辑</a-button>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="AccessKey"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_AccessKey',{rules: [{ required: true, message: '请输入AccessKey' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_AccessKey || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="AccessKeySecret"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_AccessKeySecret',{rules: [{ required: true, message: '请输入AccessKeySecret' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_AccessKeySecret || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="Host"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_Host',{rules: [{ required: true, message: '请输入Host' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_Host || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="RegionId"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_RegionId',{rules: [{ required: true, message: '请输入RegionId' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_RegionId || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="DBInstanceId"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_DBInstanceId',{rules: [{ required: true, message: '请输入DBInstanceId' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_DBInstanceId || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row class="form-row" :gutter="16">
          <a-col :xl="{span: 16}" :lg="{span: 16}" :md="{span: 24}" :sm="24">
            <a-form-item
              label="数据库地址"
              :labelCol="{lg: {span: 6}, sm: {span: 4}}"
              :wrapperCol="{lg: {span: 16}, sm: {span: 12} }">
              <a-input v-show="isEdit" v-decorator="['rds_Address',{rules: [{ required: true, message: '请输入数据库地址' }], validateTrigger: 'change'}]"/>
              <span v-if="!isEdit">{{ data.rds_Address || '--' }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>
    </a-form>
  </div>
</template>
<script>
import _ from 'lodash'
import { getPre, saveConfig } from '@/api/system'
import { mixin, mixinDevice } from '@/utils/mixin'
import notification from 'ant-design-vue/es/notification'
export default {
  mixins: [mixin, mixinDevice],
  components: {
  },
  created () {
    this.handlePre()
  },
  data () {
    return {
      loading: false,
      isEdit: false,
      isSubmit: false,
      form: this.$form.createForm(this),
      data: {}
    }
  },
  methods: {
    handlePre () {
      getPre({ type: 'rds' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.data = _.get(res, 'data', {})
          this.form.setFieldsValue(this.data)
        }
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const data = Object.assign(this.data, this.form.getFieldsValue())
          this.isSubmit = true
          saveConfig(data).then(res => {
            if (_.get(res, 'code') === 200) {
              this.handlePre()
              this.isEdit = false
              this.isSubmit = false
              notification.success({
                message: '更新成功',
                description: '保存成功'
              })
            } else {
              this.isSubmit = false
              notification.warning({
                message: '更新失败',
                description: '请稍后再试'
              })
            }
          })
        }
      })
    }
  }
}
</script>
